import { render, staticRenderFns } from "./PromiseConfigDialog.vue?vue&type=template&id=275e6f60&scoped=true"
import script from "./PromiseConfigDialog.vue?vue&type=script&lang=js"
export * from "./PromiseConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e6f60",
  null
  
)

export default component.exports